import { render, staticRenderFns } from "./MenuBack.vue?vue&type=template&id=0cdbe494&scoped=true&"
import script from "./MenuBack.vue?vue&type=script&lang=js&"
export * from "./MenuBack.vue?vue&type=script&lang=js&"
import style0 from "./MenuBack.vue?vue&type=style&index=0&id=0cdbe494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbe494",
  null
  
)

export default component.exports